module.exports = __webpack_public_path__ + "static/media/dev-banner.849a021f.png";